"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressStepperStepDot = void 0;
var _ProgressStepperStepDot = require("./ProgressStepperStepDot");
// TODO: in v9, move styled() from ProgressStepperStepDot.jsx to here
var StyledProgressStepperStepDot = _ProgressStepperStepDot.ProgressStepperStepDot;
exports.StyledProgressStepperStepDot = StyledProgressStepperStepDot;